<template>
    <div :class="{'setbgW':toset==true}" style="width: 100%; position: fixed; height: 45px; z-index:99999;">



        <div v-if="pgdata" style="padding: 5px 0px;color: #222;" class="container spacestart alicenter">
            <div v-if="pgdata.topnavinfo.logoimg!=''" style="width: 35px;height: 35px;flex-shrink: 0;">
                <img :src="pgdata.topnavinfo.logoimg" width="100%"/>
            </div>

            <div v-if="pgdata.topnavinfo.showname==true" class="" style=" margin-left: 15px;">
                <div  style="margin-left:10px;">
                    <div style="font-size: 18px;">{{pgdata.appname}}</div>
                </div>
            </div>

            <div style="width: 100%;margin-left: 45px;">
                <div v-if="pgdata.topnavinfo.navlist" class="spacestart alicenter">
                    <div v-for="it,i in pgdata.topnavinfo.navlist" :key="i"
                         @mouseenter="moushowpop"
                         @mouseleave="mouclospop"
                         :attType="it.type"
                         :attInum="i"
                         class="navbox">

                        <span v-if="it.type=='rout'" @click="gotorout(it)" class="navboxrout"
                              :class="{'setred':check_nowroutname(it)==true}">
                            {{it.name}}
                        </span>

                        <a    v-if="it.type=='link'" :href="it.url" :target="it.target">{{it.name}}</a>
                        <span v-if="it.type=='txt'">{{it.name}}</span>

                        <span  v-if="it.type=='imgcode'">
                            {{it.name}}
                        </span>

                        <div v-if="it.type==='imgcode'" :ref="'imgcodebox'+i"
                             style="position: fixed; width: 200px;height: 200px; border-radius: 8px;overflow: hidden;
                             box-shadow:  0 0 30px rgba(0,0,0,0.3);
                             z-index:999;display: none;">

                            <div style="width: 200px;height: 200px;overflow: hidden;">
                                <img v-if="it.imgurl!==''" :src="it.imgurl" width="100%"/>
                            </div>

                        </div>

                    </div>

                </div>


            </div>


            <div style="width: 190px;flex-shrink: 0;" class="spaceend alicenter">
                <div style="font-size: 14px;font-weight: 500">
                    <a style="text-decoration: none;
                    padding: 8px 16px;background-color: #e95640;color: #ffffff;
                    border-radius: 32px;box-shadow: 0 0 8px 0  rgba(252,117,22, 0.3);
" class="acw" v-if="islogin!=true" href="http://passport.goyoku.com/?Rturl=http://www.goyoku.com" target="_blank">
                        <i class="iconfont icon-denglu" style="font-size: 13px;margin-right: 3px;"/>
                        <span>登录有库账户[全站通]</span>
                    </a>

                    <a style="text-decoration: none;padding: 8px 16px;

                    background-color: #0066ff;box-shadow: 0 0 8px 0  rgba(0,111,217, 0.3); color: #ffffff;border-radius: 32px;
" class="acw" v-if="islogin==true" href="http://ucenter.goyoku.com" target="_blank">
                        <i style="font-size: 13px;margin-right: 3px;" class="iconfont icon-yonghuzhongxin"/>
                        <span>用户中心</span>
                    </a>

                </div>
            </div>
        </div>



    </div>
</template>

<script>
    export default {
        name: "topnav",
        data(){
            return{
                toset:false,

                pgdata:null,

                islogin:false,

                nowimgcodebox:null,
            }
        },

        created() {

            var nowpuid = this.check_havecookie();
            if(nowpuid!==''){
                this.islogin=true;
            }




            //this.get_webpuid();
            //console.log(window.ttdata);

            if(window.ttdata!=null&&window.ttdata!=undefined&&window.ttdata!='') {
                try{
                    this.pgdata=window.ttdata;
                }catch (e) {
                    this.pgdata=null;
                }


            }

        },
        methods:{
            mouclospop(e){
               if(this.nowimgcodebox){
                   this.nowimgcodebox.style.display='none';
               }
            },
            moushowpop(e){

                var objtype = e.target.getAttribute('attType');
                var objinum = e.target.getAttribute('attInum');
                if(objtype!=='imgcode'){
                    return false;
                }
               // console.log(e);
                var clientX = e.clientX;
                var clientY = e.clientY;

                this.nowimgcodebox=null;
                //imgcodediv.style.display='block';
                this.$nextTick(()=>{
                    var imgcodediv = this.$refs['imgcodebox'+objinum][0];
                    imgcodediv.style.display='block';
                    this.nowimgcodebox=imgcodediv;

                })
                //this.showpop=true;
                //console.log(imgcodediv);


            },


            gotorout(it){
                //console.log(it);
                var nowroutname = this.$route.name;
                if(nowroutname===it.keyname){return false;}


                var path='/';
                if(it.url!=''){path=it.url;}
                //alert(path);
                if(it.valval!='') {
                    this.$router.push({'path': path, query: {'id': it.valval}})
                }
                if(it.valval==''){
                    this.$router.push({'path': path})
                }
            },

            check_nowroutname(it){
                var nowroutname = this.$route.name;
               if(nowroutname===it.keyname){return true;}
                return false;
            },

            get_webpuid(){
                var puid = this.$cookie.get('puid');
                if(puid=="underfind"||puid==null||puid==''){
                    this.islogin=false;
                }else{
                    this.islogin=true;
                }

            },
            set_bgW(setval){
                this.toset=setval;
            },


        },
    }
</script>

<style scoped>
    .hide {
        display: none;
        transition: all 2s ease-out;
        opacity: 0;
    }

    .setred{color: #004ecc;}

    .setred::after {
        content: ""; /* 必须有content属性，即使是空字符串 */
        display: block; /* 将伪元素显示为块级元素 */
        margin-top: 3px;
        border-bottom: 2px solid #0066ff; /* 设置横线的样式 */
        width: 100%; /* 横线宽度 */
    }




    a{
        text-decoration: none;
        color: #3a3a3a;
    }
    .navbox{
        margin-right: 28px;font-size: .9rem;
        font-weight: 400;
        color: #545454;
        cursor: pointer;
        position: relative;
    }

    .navbox::after {
        content: '';
        position: absolute;
        width: 0%; /* 初始宽度 */
        height: 2px;
        background-color: #0066ff;
        left: 0;
        bottom: -4px; /* 根据需要调整 */
        transition: width 0.2s ease-out; /* 过渡效果 */
    }
    .navbox:hover::after{
        width: 100%;
    }

    .navbox:hover{
        color: #0066ff;
    }


    @keyframes changeBackground {
        0%   { background-color: transparent; }
        100% { background-color: #fff; }
    }
    .setbgW{
        background-color: #ffffff;
        box-shadow: 0 0 3px #cccccc;

        animation-name: changeBackground;
        animation-duration: .8s; /* 动画持续时间 */
        animation-iteration-count: 1; /* 动画无限次数播放 */
        animation-timing-function: ease-in-out; /* 动画速度变化 */
    }

    .acw{color: #222222
    }
    .ac-act{
        color: #0066ff;
    }
    .acw:hover{
        color: #0066ff;
    }

</style>



// WEBPACK FOOTER //
// src/components/comp/topnav.vue